// File: cgp-app-card.component.ts
// Author: Joseph M Diaz
// Date: 6/6/2018
// Desc: Component for the cgp app card.
// Other Contributors:

import { Component, Input } from '@angular/core';

import { AppService } from '../../app.service';

@Component({
    selector: 'cgp-app-card',
    templateUrl: './cgp-app-card.template.html',
    styleUrls: ['./cgp-app-card.style.scss']
})
export class CgpAppCardComponent {
    private readonly _fullScreenToggled: any;

    @Input() titleText;
    @Input() showFullScreenToggle = false;
    @Input() showBackButton = false;
    @Input() onBackButtonClicked;
    @Input() backButtonTooltip = '';

    isFullScreen;

    constructor(private readonly appService: AppService) {
        this.isFullScreen = this.appService.isFullScreen();

        this._fullScreenToggled = appService.fullScreenToggled.subscribe((isFullScreen) => {
            this.isFullScreen = isFullScreen;
        });
    }

    ngOnDestroy() {
        this._fullScreenToggled.unsubscribe();
        this.onBackButtonClicked = null;
    }

    fullScreenToggleToolTip() {
        return this.isFullScreen ? 'Collapse' : 'Expand';
    }

    toggleFullScreen() {
        this.appService.toggleFullScreen();
    }

    onBackButtonClick() {
        if (this.onBackButtonClicked) {
            this.onBackButtonClicked();
        }
    }
}
